(function () {
  'use strict';

  var WIDGET_TYPE = 'dynamic_bundle';
  var ENDPOINT = 'https://options.shopapps.site/v2/';
  var CACHE_PREFIX = 'rebuy-bold-options:';

  var TEXT_TYPES = ['textbox', 'textarea'];

  var pending = {};

  function shopDomain() {
    if (window.Shopify && Shopify.shop) return Shopify.shop;
    if (window.Rebuy && Rebuy.shop && Rebuy.shop.myshopify_domain) {
      return Rebuy.shop.myshopify_domain;
    }
    return null;
  }

  function cached(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function cache(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
    }
  }

  function toDefinitions(payload) {
    var optionProduct = payload && payload.option_product;
    var sets = (optionProduct && optionProduct.option_sets) || [];
    var definitions = [];

    sets.forEach(function (set) {
      (set.options || []).forEach(function (option) {
        if (TEXT_TYPES.indexOf(option.type) === -1) return;
        var name = option.public_name || option.internal_name;
        if (!name) return;

        definitions.push({
          id: option.id,
          name: name,
          label: name,
          required: Boolean(option.required),
          max_size: option.max_size > 0 ? option.max_size : null
        });
      });
    });

    return definitions;
  }

  function toFields(definitions) {
    return definitions.map(function (definition) {
      return {
        id: definition.id,
        name: definition.name,
        label: definition.label,
        required: definition.required,
        max_size: definition.max_size,
        value: '',
        invalid: false
      };
    });
  }

  function loadDefinitions(productId) {
    var shop = shopDomain();
    if (!shop) return Promise.resolve([]);

    var key = CACHE_PREFIX + shop + ':' + productId;
    var hit = cached(key);
    if (hit) return Promise.resolve(hit);
    if (pending[key]) return pending[key];

    pending[key] = fetch(ENDPOINT + shop + '/generate_option/' + productId)
      .then(function (response) {
        if (!response.ok) throw new Error('Bold options ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        var definitions = toDefinitions(payload);
        cache(key, definitions);
        return definitions;
      })
      .catch(function () {
        return [];
      })
      .then(function (definitions) {
        delete pending[key];
        return definitions;
      });

    return pending[key];
  }

  function personalizationOption(product) {
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i] && /personaliz/i.test(options[i].name || '')) return options[i];
    }
    return null;
  }

  function personalizationOn(product) {
    var option = personalizationOption(product);
    if (!option) return true;

    var variant = product.selected_variant;
    if (!variant) return false;

    var value = variant['option' + option.position];
    if (!value) return false;

    return !/\bno\b|\bwithout\b/i.test(value);
  }

  function vueOf(widget) {
    return (widget && widget.View && widget.View.vue) || null;
  }

  function setReactive(widget, target, key, value) {
    var vue = vueOf(widget);
    if (vue && typeof vue.$set === 'function') {
      vue.$set(target, key, value);
    } else {
      target[key] = value;
    }
  }

  function applyVisibility(widget, product) {
    var state = product.personalization;
    if (!state) return;

    var visible = state.fields.length > 0 && personalizationOn(product);
    if (state.visible === visible) return;
    state.visible = visible;

    if (!visible) {
      state.fields.forEach(function (field) {
        field.value = '';
        field.invalid = false;
        if (product.properties) product.properties[field.name] = '';
      });
    }
  }

  function missingEntries(widget) {
    var missing = [];

    (widget.data.products || []).forEach(function (product) {
      var state = product.personalization;
      if (!state || !state.visible) return;
      if (product.selected === false) return;
      if (typeof widget.variantAvailable === 'function' &&
          !widget.variantAvailable(product.selected_variant)) {
        return;
      }

      state.fields.forEach(function (field) {
        if (!String(field.value || '').trim()) missing.push(field);
      });
    });

    return missing;
  }

  function focusFirstError(widget) {
    var vue = vueOf(widget);

    var reveal = function () {
      var input = document.querySelector(
        '#rebuy-widget-' + widget.id + ' .rebuy-product-personalization__input--error'
      );
      if (input) input.focus();
    };

    if (vue && typeof vue.$nextTick === 'function') vue.$nextTick(reveal);
    else window.setTimeout(reveal, 0);
  }

  function interceptAddToCart(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest('.rebuy-bundle__actions-buttons .rebuy-button');
    if (!button) return;

    var root = button.closest('.rebuy-widget.widget-type-dynamic-bundle');
    if (!root) return;

    var widget = resolveWidget(String(root.id).replace('rebuy-widget-', ''));
    if (!widget || !widget.data) return;

    var missing = missingEntries(widget);
    if (!missing.length) return;

    event.preventDefault();
    event.stopPropagation();

    missing.forEach(function (field) {
      field.invalid = true;
    });

    focusFirstError(widget);
  }

  function prepare(widget, product) {
    if (!product || product.personalization) return;

    setReactive(widget, product, 'personalization', { visible: false, fields: [] });

    loadDefinitions(product.id).then(function (definitions) {
      if (!definitions.length) return;
      var fields = toFields(definitions);

      if (!product.properties) setReactive(widget, product, 'properties', {});
      fields.forEach(function (field) {
        setReactive(widget, product.properties, field.name, '');
      });

      product.personalization.fields = fields;
      applyVisibility(widget, product);
    });
  }

  function prepareWidget(target) {
    var widget = resolveWidget(target);
    if (!widget || !widget.data || !widget.data.config) return;
    if (widget.data.config.type !== WIDGET_TYPE) return;

    (widget.data.products || []).forEach(function (product) {
      prepare(widget, product);
    });
  }

  function resolveWidget(target) {
    if (!target) return null;
    if (typeof target === 'object') return target;

    var widgets = (window.Rebuy && window.Rebuy.widgets) || [];
    for (var i = 0; i < widgets.length; i++) {
      if (String(widgets[i].id) === String(target)) return widgets[i];
    }
    return null;
  }

  function chain(name, handler) {
    var existing = window.Rebuy.callbacks[name];

    window.Rebuy.callbacks[name] = function () {
      try {
        handler.apply(null, arguments);
      } catch (error) {
        if (window.console) console.error('Rebuy personalization: ' + name, error);
      }
      if (typeof existing === 'function') existing.apply(this, arguments);
    };
  }

  window.Rebuy = window.Rebuy || {};
  window.Rebuy.callbacks = window.Rebuy.callbacks || {};

  chain('ready', function (widgetId) {
    prepareWidget(widgetId);
  });

  chain('productsChange', function (products, widgetId) {
    prepareWidget(widgetId);
  });

  chain('selectedVariantChange', function (variant, product, widgetId) {
    applyVisibility(resolveWidget(widgetId), product);
  });

  document.addEventListener('click', interceptAddToCart, true);

  prepareExisting();

  function prepareExisting() {
    ((window.Rebuy && window.Rebuy.widgets) || []).forEach(prepareWidget);
  }
})();
